import React, { useState, useEffect } from "react";
import GitHubCalendar from "react-github-calendar";
import { Row } from "react-bootstrap";

function Github() {
  const currentYear = new Date().getFullYear();
  const [totalContributions, setTotalContributions] = useState(null);
  const [selectedYear, setSelectedYear] = useState("last");
  const [availableYears, setAvailableYears] = useState([
    currentYear.toString(),
    (currentYear - 1).toString(),
    (currentYear - 2).toString(),
  ]);
  const [yearlyTotals, setYearlyTotals] = useState({});
  const username = "mujeebkhan3771";

  useEffect(() => {
    fetch(`https://github-contributions-api.jogruber.de/v4/${username}`)
      .then((res) => res.json())
      .then((data) => {
        if (data && data.total) {
          setYearlyTotals(data.total);
          const years = Object.keys(data.total).sort((a, b) => b - a);
          if (years.length > 0) {
            setAvailableYears(years);
          }
          const total = Object.values(data.total).reduce(
            (acc, curr) => acc + curr,
            0,
          );
          setTotalContributions(total);
        }
      })
      .catch((err) => {
        console.error("Error fetching total GitHub contributions:", err);
      });
  }, [username]);

  const tabs = [
    { key: "last", label: "Last Year" },
    ...availableYears.map((year) => ({
      key: year,
      label:
        yearlyTotals[year] !== undefined
          ? `${year} (${yearlyTotals[year]})`
          : year,
    })),
  ];

  return (
    <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
      <h1 className="project-heading" style={{ paddingBottom: "20px" }}>
        Contributions Made After Completion of Projects
      </h1>

      {/* Year-wise fixed Tabs */}
      {/* <div className="year-tabs-container">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            type="button"
            className={`year-tab-btn ${selectedYear === tab.key ? "active" : ""}`}
            onClick={() => setSelectedYear(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div> */}

      <GitHubCalendar
        key={selectedYear}
        username={username}
        year={selectedYear === "last" ? "last" : Number(selectedYear)}
        blockSize={15}
        blockMargin={5}
        color="#c084f5"
        fontSize={16}
        labels={
          totalContributions !== null
            ? {
                totalCount:
                  selectedYear === "last"
                    ? `${totalContributions} total contributions`
                    : `{{count}} contributions in {{year}} (${totalContributions} total)`,
              }
            : undefined
        }
      />
    </Row>
  );
}

export default Github;
